export default __webpack_public_path__ + "static/media/david_gallacher.662fa1ed.gif";